import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

import AppLayout from './AppLayout';
import AppRouter from './AppRouter';
import { configureStore } from './store/configureStore';

import '././assets/fonts/Montserrat/Montserrat-Regular.woff';
import '././assets/fonts/Montserrat/Montserrat-SemiBold.woff';
import '././assets/fonts/Montserrat/Montserrat-Light.woff';
import '././assets/fonts/Merriweather/Merriweather-Regular.ttf';


const store = configureStore();

const AppContainer = () => {
  return (
    <Provider store={store}>
      <HelmetProvider>
        <AppLayout>
          <BrowserRouter>
            <AppRouter />
          </BrowserRouter>
        </AppLayout>
      </HelmetProvider>
    </Provider>
  );
};

AppContainer.propTypes = {};

export default AppContainer;
